<template>
 <div class="box" v-if="info">
    <div class="box">
    <FansText :str="activity"></FansText>
    <div class="fans">
        <div id="fansactive" ref="chart"></div>
    </div>
  </div>
  </div>
  <div v-else class="chart">
    <none-data :height="3.5" />
  </div>
</template>

<script>
  import FansText from "@/components/FansText.vue";
export default {
      props: {
      info: { type: Object },
    },
    components: { FansText },
  data() {
    return {
      color: [],
      data: []
    }
  },
  methods: {
              // 字体适配
  FontChart(res) {
          //获取到屏幕的宽度
          var clientWidth =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth; 
          if (!clientWidth) return; //报错拦截：
          let fontSize = 10 * (clientWidth / 1920);
          return res * fontSize;
        },
    drawChart() {
      this.data = this.data.sort((a, b) => b.value - a.value).slice() //排序取前4
      const color = ['#f1c757','#a6c9f7','#5b9bef','#c8dff9']
      this.data.forEach((item,index) =>  this.color.push(color[index]))
      echarts.init(document.getElementById('fansactive')).setOption({
        color: this.color,
        tooltip: {
          textStyle: {
            fontSize: this.FontChart(4), // 字体大小
          },
          trigger: 'item',
          formatter: val => {
            return `<div style="display: inline-block;margin-right: 5px;border-radius: 5px;width: 10px;height:10px;background:linear-gradient(180deg,rgba(42,137,244,1) 0%,rgba(187,219,255,1) 100%);"></div>
            ${val.name}`;
          },
          borderWidth:0,
        },
        series: [    
          {
            label: {
              fontSize: this.FontChart(5),
            },
            name: '粉丝活跃度',
            type: 'pie',
            radius: '70%',
            center: ['50%', '50%'],
            data: this.data,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      });
    }
  },
  computed: {
    activity() {
      const arr = this.flag ? ['活跃','不活跃','非常活跃','一般活跃'] : ['非常活跃', '一般活跃']
      const obj = this.info;
      if (obj) {
        const arr2 = []
      Object.getOwnPropertyNames(obj).forEach((key,index) => {
        if(key !== '__ob__') {
          arr2.push(+obj[key] * 100)
          this.data.push({
                value:  Number(+obj[key] * 100 || 0),name: `${arr[index]}：` + (+obj[key] * 100).toFixed(2) +'%'})
        }
      })
      return`${arr[arr2.indexOf(Math.max(...arr2))]}活跃的粉丝居多，占${arr2[arr2.indexOf(Math.max(...arr2))].toFixed(2)}%`
    }
    },
    flag() {
      const obj = this.info;
      return  Object.entries(obj).length === 4 ? true : false    
    }
  },
  mounted() {
    if(this.info && this.info !== {}) {
      this.drawChart();
    }
    },
}
</script>

<style scoped lang='less'>
.chart{
  width: 100%;
  height: 190px;
  justify-content: center;
  align-items: center;
  display: flex;
}

#fansactive {
  width: 100%;
  height: 170px;
}
</style>
